import { atom } from "@mongez/react-atom";
import type {
  Category,
  Product,
  ProductsListFilter,
  ProductsListParams,
} from "core/catalog";
import type { Breadcrumb, PaginationInfo } from "core/shared";

type ProductsListAtom = {
  products: Product[];
  category?: Category;
  filters: ProductsListFilter;
  paginationInfo: PaginationInfo;
  params: ProductsListParams;
  defaultParams: ProductsListParams;
  breadcrumbs: Breadcrumb[];
  isLoading: boolean; // will be used with filtering and sorting but keep UI existing (no full page reload)
  isLoadingMore: boolean; // will be used with loading more products (no full page reload)
};

export const productsListAtom: any = atom<ProductsListAtom>({
  key: "products-list",
  default: {},
});
